module.exports = __webpack_public_path__ + "static/media/drink.2ddcbdfe.png";